import { render, staticRenderFns } from "./vehicleDisassemblyWaste.vue?vue&type=template&id=e5b4e11a&scoped=true&"
import script from "./vehicleDisassemblyWaste.vue?vue&type=script&lang=js&"
export * from "./vehicleDisassemblyWaste.vue?vue&type=script&lang=js&"
import style0 from "./vehicleDisassemblyWaste.vue?vue&type=style&index=0&id=e5b4e11a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b4e11a",
  null
  
)

export default component.exports